module.exports = __webpack_public_path__ + "img/room.03d21bae.png";